export const ENV = {
  production: !(window.location.hostname === 'localhost' || window.location.hostname.indexOf('girino-test') > -1)
}
